<template>
  <div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card v-can="'view-product-contract'" title="PRODUCT CONTRACTS" >
          <div slot="no-body" class="mt-4">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="15%" sort-key="project_brief_code">DATE</vs-th>
                <vs-th width="15%" sort-key="project_brief_code">EXPIRE DATE</vs-th>
                <vs-th width="10%" sort-key="project_brief_code">CONTRACTS PRODUCT CODE</vs-th>
                <vs-th width="15%" sort-key="name">NOTE</vs-th>
                <vs-th width="15%">ITEMS</vs-th>
                <vs-th width="20%">STATUS</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td :data="data[indextr].expiry_timestamp">
                    {{__dateTimeFormatter(data[indextr].expiry_timestamp)}}
                  </vs-td>

                  <vs-td :data="data[indextr].contract_product_code">
                    {{ data[indextr].contract_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    {{ data[indextr].note}}
                  </vs-td>

                  <vs-td :data="data[indextr].items">
                    <span v-if="data[indextr].items.length > 0" v-for="item in data[indextr].items" :key="item.formulation_code">
                      <a>{{ item.formulation_code }}</a> ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" transparent :color="productContractsColorFactory(data[indextr].status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button class="mr-2"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-full">
                      <div class="con-btns-user flex items-center justify-between">
                        <div class="con-userx flex items-center justify-start">
                        </div>
                        <div class="flex mb-4">
                        </div>
                      </div>

                      <div class="vx-row mb-1 px-24">
                        <div class="vx-col md:w-full w-full md:mb-0">
                          <vs-table stripe :data="tr.items">

                            <template slot="thead">
                              <vs-th>FINISHED PRODUCT CODE</vs-th>
                              <vs-th>CONTRACT QUANTITY ORDERED (KG)</vs-th>
                              <vs-th>CONTRACT QUANTITY (KG)</vs-th>
                            </template>

                            <template slot-scope="{data}">
                              <vs-tr :key="item_index" v-for="(tr_item, item_index) in data">

                                <vs-td :data="tr_item.formulation_code">
                                  {{ tr_item.formulation_code }}
                                </vs-td>

                                <vs-td :data="tr_item.contract_quantity_ordered">
                                  {{ tr_item.contract_quantity_ordered }}
                                </vs-td>

                                <vs-td :data="tr_item.contract_quantity">
                                  {{ tr_item.contract_quantity }}
                                </vs-td>

                                <template class="expand-user" slot="expand">
                                  <div class="con-expand-users w-full">
                                    <div class="con-btns-user flex items-center justify-between">
                                      <div class="con-userx flex items-center justify-start">
                                      </div>
                                      <div class="flex mb-4">
                                      </div>
                                    </div>

                                    <div class="vx-row mb-1 px-24">
                                      <div class="vx-col md:w-full w-full md:mb-0">
                                        <vs-table stripe :data="tr_item.tiers">

                                          <template slot="thead">
                                            <vs-th>MinOQ</vs-th>
                                            <vs-th>MaxOQ</vs-th>
                                            <vs-th>PRICE Excl VAT/Tax in {{__accountCurrency()}}</vs-th>
                                          </template>

                                          <template slot-scope="{data}">
                                            <vs-tr :key="tier_index" v-for="(tr_tier, tier_index) in data">


                                              <vs-td :data="tr_tier.from">
                                                {{ tr_tier.from }}
                                              </vs-td>

                                              <vs-td :data="tr_tier.to">
                                                {{ tr_tier.to }}
                                              </vs-td>

                                              <vs-td :data="tr_tier.price">
                                                {{ tr_tier.price }}
                                              </vs-td>

                                            </vs-tr>
                                          </template>

                                        </vs-table>
                                      </div>
                                    </div>

                                  </div>
                                </template>

                              </vs-tr>
                            </template>

                          </vs-table>
                        </div>
                      </div>

                    </div>
                  </template>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
<!--    <create-customer-product-contracts-pop-up ref="createCustomerProductContractsPopUp"/>-->
<!--    <update-customer-project-brief-pop-up ref="updateCustomerProjectBriefPopUp"/>-->
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  // import CreateCustomerProductContractsPopUp from '@/components/popups/customer/product-contracts/CreateCustomerProductContractsPopUp'
  // import UpdateCustomerProjectBriefPopUp from '@/components/popups/customer/project-brief/UpdateCustomerProjectBriefPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: ''
      }
    },
    components: {
      'v-select': vSelect,
      // CreateCustomerProductContractsPopUp,
      // UpdateCustomerProjectBriefPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getListOfProductContracts(this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close()
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerProductContractsPopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerProjectBriefPopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }
      },
      productContractsColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
